<template>
  <div class="batch_transfer_dialog">
    <custom-dialog width="90%" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body ubv" style="height: 100%">
        <el-form :model="form" label-position="top" ref="form" :rules="rules">
          <el-row>
            <el-col :span="2" v-if="model.type === 'hq'">
              <el-form-item :label="$t('dms_batch_transfer_dialog.mu_biao_zu_zhi')">
                <el-select v-model="targetType" :placeholder="$t('Common.com_please_select')" @change="changeTargetType">
                  <el-option :label="$t('dms_batch_transfer_dialog.zi_gong_si')" value="org"></el-option>
                  <el-option :label="$t('dms_batch_transfer_dialog.zong_bu')" value="orgHq"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$t('dms_batch_transfer_dialog.mu_biao_zu_zhi')" prop="consigneeOrgId" :class="{ 'label-white': model.type === 'hq' }">
                <custom-select
                  v-if="targetType === 'org'"
                  :filterable="true"
                  :model="form"
                  v-model="form.consigneeOrgId"
                  url="OrganStockTarget"
                  :props="{ label: 'orgName', value: 'orgId', map: { orgType: 'orgType', orgName: 'consigneeOrgName' } }"
                  @change="onChangeTarget"
                  width="90%"
                ></custom-select>
                <custom-select
                  v-if="targetType === 'orgHq'"
                  :filterable="true"
                  :model="form"
                  v-model="form.consigneeOrgId"
                  url="OrganHqList"
                  :props="{ label: 'orgName', value: 'orgId', map: { orgType: 'orgType', orgName: 'consigneeOrgName' } }"
                  :params="{ isExcludeSelf: true }"
                  @change="onChangeTarget"
                  width="90%"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$t('dms_batch_transfer_dialog.fa_huo_dan_hao')" prop="shipmentNum">
                <el-input maxlength="30" v-model="form.shipmentNum" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_batch_transfer_dialog.ye_wu_lei_xing')" prop="bizType">
                <el-radio-group v-model="form.bizType">
                  <el-radio :label="90" :disabled="form.orgType == 'CS'">{{ $t('dms_batch_transfer_dialog.ku_cun') }}</el-radio>
                  <el-radio :label="10" :disabled="form.orgType == 'HQ' || form.orgType == 'JV' || form.orgType == 'SC' || form.orgType == 'JV_SC'">{{ $t('dms_batch_transfer_dialog.shi_yong') }}</el-radio>
                  <el-radio :label="20" :disabled="form.orgType == 'HQ' || form.orgType == 'JV' || form.orgType == 'SC' || form.orgType == 'JV_SC'">{{ $t('dms_batch_transfer_dialog.zu_lin') }}</el-radio>
                  <el-radio :label="40" :disabled="form.orgType == 'HQ' || form.orgType == 'SC'">{{ $t('dms_batch_transfer_dialog.xiao_shou') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="targetType === 'org'">
              <el-form-item :label="$t('dms_batch_transfer_dialog.sfzdsh')">
                <el-select v-model="isAutoReceive" :placeholder="$t('Common.com_please_select')" style="width: 96%">
                  <el-option :label="$t('Common.com_yes')" :value="1"></el-option>
                  <el-option :label="$t('Common.com_no')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-wrap ubv ub-f1">
          <custom-tab v-model="showTab" :list="tabList" @change="tabChange"></custom-tab>
          <div class="box ubv ub-f1">
            <div class="search-hd">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item v-if="showTab === '2'">
                  <el-button :disabled="!selectOut.length" @click="removeSelect">
                    <i class="icon icon-shanchu"></i>
                    <span>&ensp;{{ $t('dms_batch_transfer_dialog.pi_liang_shan_chu') }}</span>
                  </el-button>
                </el-form-item>
                <el-form-item style="float: right" v-if="showTab === '1'">
                  <search-input v-model="formSearch.search" :placeholder="$t('dms_batch_transfer_dialog.jshmodemSNrkdh')" @fetch="onPageChange({ page: 1 })"></search-input>
                </el-form-item>
                <!-- 高级搜索 -->
                <el-form-item style="float: right" v-if="showTab === '1'">
                  <switch-button :link="link"></switch-button>
                </el-form-item>
              </el-form>
            </div>
            <switch-container v-if="showTab === '1'" @search="onPageChange({ page: 1 })" @clear="clearFilter()" ref="container">
              <el-form :inline="true" label-position="top">
                <el-form-item :label="$t('dms_batch_transfer_dialog.chan_pin_xing_hao')">
                  <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
                </el-form-item>
                <el-form-item :label="$t('dms_batch_transfer_dialog.ku_cun_fang')" v-if="model.type !== 'hq'">
                  <custom-select
                    width="100%"
                    v-model="formSearch.stockOrgId"
                    :listenter="form.consigneeOrgId"
                    url="OrganStockInventory"
                    :params="{ excludeOrgId: form.consigneeOrgId }"
                    :props="{ label: 'orgName', value: 'orgId' }"
                  ></custom-select>
                </el-form-item>
                <el-form-item :label="$t('dms_batch_transfer_dialog.ru_ku_shi_jian')">
                  <custom-date-picker
                    style="width: 100%"
                    @change="onPageChange({ page: 1 })"
                    v-model="formSearch.dataTimes"
                    type="daterange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    :picker-options="beforeToday"
                  ></custom-date-picker>
                </el-form-item>
              </el-form>
            </switch-container>
            <div class="table-bd" v-if="showTab === '1'">
              <custom-table key="1" v-model="selectIn" height="100%" type="checkbox" tableCode="stockTransfer" :data="tableList" @filter="filterChange" @column="setColumn"></custom-table>
            </div>
            <div class="table-bd" v-if="showTab === '2'">
              <custom-table
                key="2"
                index
                height="100%"
                v-model="selectOut"
                type="checkbox"
                tableCode="stockTransfer1"
                :data="selectList"
                @filter="filterChange"
                @column="setColumn"
                :filterArr="tableColumnFilter"
                :slots="['deviceBizType', 'orderCharged', 'shipmentTime', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime', 'locationSiteName']"
              >
                <template v-slot:deviceBizType="scope">
                  <custom-select :clearable="false" v-model="scope.row.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
                </template>
                <template v-slot:orderCharged="scope">
                  <custom-select :clearable="false" v-model="scope.row.orderCharged" code="isynergy_cloud_bool" width="100%"></custom-select>
                </template>
                <template v-slot:shipmentTime="scope">
                  <custom-date-picker
                    style="width: 100%"
                    v-model="scope.row.shipmentTime"
                    type="date"
                    :placeholder="scope.$index === 0 ? '' : $t('dms_batch_transfer_dialog.mo_ren_tong_shang')"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="changeSaleTime($event, scope.row)"
                  ></custom-date-picker>
                </template>
                <template v-slot:rentalSaleTime="scope">
                  <custom-date-picker
                    style="width: 100%"
                    v-model="scope.row.rentalSaleTime"
                    type="date"
                    :placeholder="scope.$index === 0 ? '' : $t('dms_batch_transfer_dialog.mo_ren_tong_shang')"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="changeSaleTime($event, scope.row)"
                  ></custom-date-picker>
                </template>
                <template v-slot:rentalStartTime="scope">
                  <custom-date-picker
                    style="width: 100%"
                    v-model="scope.row.rentalStartTime"
                    type="date"
                    :placeholder="scope.$index === 0 ? '' : $t('dms_batch_transfer_dialog.mo_ren_tong_shang')"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    :picker-options="{
                      disabledDate(time) {
                        return scope.row.rentalEndTime ? $moment(time).isAfter(new Date(`${scope.row.rentalEndTime}Z`).getTime(), 'day') : undefined;
                      },
                    }"
                  ></custom-date-picker>
                </template>
                <template v-slot:rentalEndTime="scope">
                  <custom-date-picker
                    style="width: 100%"
                    v-model="scope.row.rentalEndTime"
                    type="date"
                    :placeholder="scope.$index === 0 ? '' : $t('dms_batch_transfer_dialog.mo_ren_tong_shang')"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    :picker-options="{
                      disabledDate(time) {
                        return scope.row.rentalStartTime
                          ? $moment(time).isBefore(new Date(`${scope.row.rentalStartTime}Z`).getTime(), 'day') || $moment(time).isBefore(new Date().getTime(), 'day')
                          : $moment(time).isBefore(new Date().getTime(), 'day');
                      },
                    }"
                  ></custom-date-picker>
                </template>
                <template v-slot:locationSiteName="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.locationSiteName"
                    :placeholder="scope.$index === 0 ? '' : $t('dms_batch_transfer_dialog.mo_ren_tong_shang')"
                    style="width: 120px; vertical-align: middle"
                    :disabled="true"
                  ></el-input>
                  <el-button size="small" style="margin-left: 8px; float: none; vertical-align: middle" type="text" @click="onSelectLocation(scope.row)">
                    {{ $t('dms_batch_transfer_dialog.xuan_ze_xiang_mu') }}
                  </el-button>
                </template>
              </custom-table>
            </div>
            <div class="table-page" v-if="showTab === '1'">
              <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button v-if="showTab === '1'" :disabled="!selectIn.length" type="primary" @click="addSelect">{{ $t('Common.com_confirm') }}</el-button>
        <el-button v-if="showTab === '2'" :disabled="!selectList.length" type="primary" @click="confirm">{{ $t('dms_batch_transfer_dialog.zhuan_yi') }}</el-button>
      </div>
    </custom-dialog>
    <location-site-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onConfirmLocation"></location-site-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { locationSiteSelectDialog },
  data() {
    return {
      tableCode: 'stockTransfer',
      isAutoReceive: 1,
      tabList: [],
      showTab: '1',
      targetType: 'org',
      form: {
        bizType: '',
        shipmentNum: '',
        consigneeOrgId: '',
        consigneeOrgName: '',
      },
      selectList: [], // 已选
      selectIn: [],
      selectOut: [],
      formSearch: {
        dataTimes: [],
        productCode: '',
        consigneeOrgId: '',
        stockOrgId: '',
        startTime: '',
        endTime: '',
        search: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      selectRow: [],
      link: undefined,
      dialogModel: {},
      dialogVisible: false,
      row: undefined,
    };
  },
  computed: {
    rules() {
      return {
        bizType: [
          {
            required: true,
            message: this.$t('dms_batch_transfer_dialog.qxzywlx'),
          },
        ],
        consigneeOrgId: [
          {
            required: true,
            message: this.$t('dms_batch_transfer_dialog.qxzmbzz'),
          },
        ],
      };
    },
    // 日期显示格式化
    tableColumnFilter: (vm) => {
      if (`${vm.form.bizType}` === '90') {
        return ['orderCharged', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime'];
      } else if (`${vm.form.bizType}` === '10' || `${vm.form.bizType}` === '20') {
        return ['shipmentTime', 'rentalSaleTime'];
      } else if (`${vm.form.bizType}` === '40') {
        return ['shipmentTime', 'rentalStartTime', 'rentalEndTime'];
      }
      return ['orderCharged', 'shipmentTime', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime'];
    },
  },
  mounted() {
    this.tabChange();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.tabList = [
      { name: this.$t('dms_batch_transfer_dialog.xuan_ze_she_bei'), value: '1' },
      { name: this.$t('dms_batch_transfer_dialog.yi_xuan_she_bei'), value: '2' },
    ];
  },
  methods: {
    changeSaleTime: function (value, row) {
      row.rentalStartTime = value;
    },
    // 选择项目
    onSelectLocation: function (row) {
      this.row = row;
      this.dialogModel.title = this.$t('dms_batch_transfer_dialog.xuan_ze_xiang_muo', [this.form.consigneeOrgName]);
      this.dialogModel.row = {
        ...row,
        orgId: this.form.consigneeOrgId,
        orgName: this.form.consigneeOrgName,
      };
      this.dialogVisible = true;
    },
    // 确认项目选择
    onConfirmLocation: function (row) {
      this.row.locationId = row.locationId;
      this.row.locationName = row.locationName;
      this.row.siteId = row.siteId;
      this.row.siteName = row.siteName;
      this.row.locationSiteName = row.siteName ? `${row.locationName}/${row.siteName}` : row.locationName;
      const data = this.selectList;
      this.selectList = [];
      this.$nextTick(() => {
        this.selectList = data;
      });
    },
    tabChange: function () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.link = this.$refs.container;
        }, 500);
      });
    },
    changeTargetType: function () {
      if (this.targetType === 'org') {
        this.showTab = '1';
        this.selectList = [];
        this.formSearch.stockOrgId = '';
        this.formSearch.search = '';
        this.tableList = [];
        this.totalRows = 0;
        this.form.consigneeOrgId = '';
      } else if (this.targetType === 'orgHq') {
        this.formSearch.stockOrgId = this.model.row.rootOrgId;
        this.getTableList();
      }
    },
    // 变更目标组织
    onChangeTarget: function () {
      this.showTab = '1';
      this.selectList = [];
      this.formSearch.search = '';
      this.tableList = [];
      this.totalRows = 0;
      this.form.bizType = '';
      if (this.form.consigneeOrgId) {
        this.getTableList();
      }
    },
    // 清空
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    formatTableRow: function () {
      const list = JSON.parse(JSON.stringify(this.tableList));
      list.forEach((item) => {
        item.isExists = !!this.selectList.find((t) => t.deviceId === item.deviceId);
      });
      this.tableList = list;
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.consigneeOrgId = this.form.consigneeOrgId;
      this.formSearch.startTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.endTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.$getJSON(apis.stockTransferPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.deviceBizType = item.nextDeviceBizType;
          item.orderCharged = '1';
          item.rentalStartTime = '';
          item.rentalEndTime = '';
          item.locationId = '';
          item.locationName = '';
        });
        this.tableList = list;
        this.totalRows = res.data.total;
        this.$nextTick(() => {
          this.formatTableRow();
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 加入
    addSelect: function () {
      this.selectIn.forEach((item) => {
        const has = this.selectList.find((t) => t.deviceId === item.deviceId);
        if (!has) {
          this.selectList.push(item);
        }
      });
      this.showTab = '2';
      this.formatTableRow();
    },
    // 移除
    removeSelect: function () {
      this.selectOut.forEach((item) => {
        this.selectList = this.selectList.filter((t) => t.deviceId !== item.deviceId);
      });
      this.formatTableRow();
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const list = this.$formatCopyUp(this.selectList, ['shipmentTime', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime', 'locationName', 'locationSiteName', 'locationId']);
        this.$postJSON(this.targetType === 'orgHq' ? apis.stockTransferHq : apis.stockTransfer, {
          deviceList: list,
          consigneeOrgId: this.form.consigneeOrgId,
          deviceBizClass: this.form.bizType,
          shipmentNum: this.form.shipmentNum,
          isAutoReceive: !!(this.targetType === 'orgHq' ? 0 : this.isAutoReceive),
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.clearKeepAlive('stockRecord');
          this.visible = false;
          this.$emit('success', this.form);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.batch_transfer_dialog {
  .label-white .el-form-item__label {
    opacity: 0;
  }
  .el-dialog__body {
    height: calc(100% - 106px);
  }
  .el-dialog {
    margin: auto !important;
    height: 100%;
  }
  .dialog-wrap {
    border: 1px solid #eef2f8;
  }
  .el-dialog__footer {
    position: relative;
    z-index: 999;
  }
  .box {
    padding: 0 16px 16px;
    position: relative;
    // height: 800px;
    overflow-y: auto;
  }
}
</style>
